// Login Usuario
export const INIT_SESSION = 'INIT_SESSION';
export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const INIT_LOGOUT = 'INIT_LOGOUT';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';


// Perfil Usuario
export const INIT_ME = 'INIT_ME';
export const ME = 'ME';
export const ME_ERROR = 'ME_ERROR';

//Historial de examenes
export const INIT_TEST_HISTORY = 'INIT_TEST_HISTORY';
export const TEST_HISTORY = 'TEST_HISTORY';
export const ERROR_TEST_HISTORY = 'ERROR_TEST_HISTORY';

//Indicadores de salud
export const INIT_HEALTH_SCORE = 'INIT_HEALTH_SCORE';
export const HEALTH_SCORE = 'HEALTH_SCORE';
export const ERROR_HEALTH_SCORE = 'ERROR_HEALTH_SCORE';


//Agenda Medica
export const INIT_MEDICAL_AGENDA = 'INIT_MEDICAL_AGENDA';
export const MEDICAL_AGENDA = 'MEDICAL_AGENDA';
export const ERROR_MEDICAL_AGENDA = 'ERROR_MEDICAL_AGENDA';
export const INIT_SAVE_RESULT_TEST = 'INIT_SAVE_RESULT_TEST';
export const SAVE_RESULT_TEST = 'SAVE_RESULT_TEST';
export const ERROR_SAVE_RESULT_TEST = 'ERROR_SAVE_RESULT_TEST';